import current_active_marker from 'src/assets/imgs/active_current_marker.png'
import current_marker from 'src/assets/imgs/current_marker.png'
import Span from 'src/components/atomic/atom/Span'
import { COLOR } from 'src/constants/colors'
import React from 'react'
import styled from 'styled-components'

interface NowMarkerProps {
  active?: boolean
  lat?: number
  lng?: number
  onClickFn?: () => void
}
const NowMarker = (props: NowMarkerProps) => {
  const { active } = props
  return (
    <NowMarkerWrap onClick={props.onClickFn} active={`${active}`}>
      <Span option={'tiny_bold'} color={COLOR.white} $line_height={'28px'}>
        NOW
      </Span>
    </NowMarkerWrap>
  )
}
export default NowMarker

const NowMarkerWrap = styled.div<{ active?: string }>`
  width: 60px;
  height: ${(props) => (props.active === 'true' ? '38px' : '28px')};
  background: ${(props) =>
    props.active === 'true'
      ? `url(${
          props.active === 'true' ? current_active_marker : current_marker
        }) no-repeat center/cover`
      : `url(${current_marker}) no-repeat center/cover`};
`
